"use strict";

exports.__esModule = true;
exports.default = void 0;

var _utils = require("./utils");

var _FieldMedia = _interopRequireDefault(require("./FieldMedia"));

var _ImageFiltersField = _interopRequireDefault(require("./ImageFiltersField"));

var _ImageFocalpointField = _interopRequireDefault(require("./ImageFocalpointField"));

var _ImageCropdataField = _interopRequireDefault(require("./ImageCropdataField"));

var _AnnotateImageField = _interopRequireDefault(require("./AnnotateImageField"));

var _AnnotateImage = _interopRequireDefault(require("./AnnotateImage"));

var _LayoutMedia = _interopRequireDefault(require("./LayoutMedia"));

var _MediaPreview = _interopRequireDefault(require("./MediaPreview"));

var _ImagePreview = _interopRequireDefault(require("./ImagePreview"));

var _VideoPreview = _interopRequireDefault(require("./VideoPreview"));

var _AudioPreview = _interopRequireDefault(require("./AudioPreview"));

var _ImageFilters = _interopRequireDefault(require("./ImageFilters"));

var _ImageCropper = _interopRequireDefault(require("./ImageCropper"));

var _ImageFocalpoint = _interopRequireDefault(require("./ImageFocalpoint"));

var _ImageAnnotations = _interopRequireDefault(require("./ImageAnnotations"));

var _SubtitlesModule = _interopRequireDefault(require("./SubtitlesModule"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// fields
// layouts
// subtitles
var _default = {
  "fieldtypes": {
    "media": _utils.getMediaField,
    "image": _utils.getImageField,
    "imageCropdata": _utils.getImageCropdataField,
    "imageFocalpoint": _utils.getImageFocalpointField,
    "imageFilters": _utils.getImageFiltersField,
    "video": _utils.getVideoField,
    "audio": _utils.getAudioField,
    "annotateImage": _utils.getAnnotateImageField
  },
  "fields": {
    "media": _FieldMedia.default,
    "imageFilters": _ImageFiltersField.default,
    "imageFocalpoint": _ImageFocalpointField.default,
    "imageCropdata": _ImageCropdataField.default,
    "annotateImage": _AnnotateImageField.default
  },
  "layouts": {
    "media": _LayoutMedia.default,
    "mediaPreview": _MediaPreview.default,
    "imagePreview": _ImagePreview.default,
    "imageCropper": _ImageCropper.default,
    "imageFocalpoint": _ImageFocalpoint.default,
    "imageFilters": _ImageFilters.default,
    "imageAnnotations": _ImageAnnotations.default,
    "videoPreview": _VideoPreview.default,
    "audioPreview": _AudioPreview.default,
    "annotateImage": _AnnotateImage.default,
    "subtitlesModule": _SubtitlesModule.default
  }
};
exports.default = _default;
module.exports = exports.default;